import React, {useState} from "react";
import { request } from "../services/utils";
import "./login.css";
import { useNotification } from "../contexts/NotificationContext";

export default function Login({history}) {
    const [isFetching, setIsFetching] = useState(false)
    const {createErrorNotification} = useNotification()

    const onSubmit = async (event) => {
        event.preventDefault();
        setIsFetching(true);
        request.post('/api/session', {
            emailAddress: document.getElementById("login-form-email-input").value,
            password: document.getElementById("login-form-password-input").value
        }).then((response) => {
            console.log("Logged in")
            const params = new URLSearchParams(window.location.search);
            const redirectTo = (params.get('redirect_to') || '').trim();
            const safeRedirectTo = redirectTo.startsWith('/') && !redirectTo.startsWith('//') ? redirectTo : '';
            history.push(safeRedirectTo || "/lms")
        }).catch((error) => {
            const message = error?.normalizedMessage || 'Login failed. Please check your email and password and try again.'
            createErrorNotification(`Error: ${message}`)
            console.error([error?.message, message].join(", "))
        }).finally(() => {
            setIsFetching(false)
        })
    }
    return (
        <div className="card">
            <p className="sign" align="center">It’s nice to see you again!</p>
            <form disabled={isFetching} className="form1" id="login-form" onSubmit={event => onSubmit(event)} autoComplete="on">
                <input disabled={isFetching} name="email" id="login-form-email-input" className="un " type="email" align="center" placeholder="Email" autoComplete="username" required></input>
                <input disabled={isFetching} name="password" id="login-form-password-input" className="pass" type="password" align="center" placeholder="Password" autoComplete="current-password" required></input>
                {isFetching ? <p className="please-wait-text">Please wait...</p> : <button disabled={isFetching} type="submit"  value="login" id="submit" className="submit" align="center">Sign in</button>}
            </form>
            <button disabled={isFetching} onClick={() => history.push("/forgot-password")} type="submit" id="submitid" className="forgotpw" align="center">Forgot password?</button>
        </div>
    );
}
